<!-- Sold lots: proceeds and cost in currency and PLN (NBP exchange rates). -->
<script lang="ts">
  import type { RealizedEntry } from "../../core/types";
  import { app } from "../../lib/state.svelte";
  import { fmtDate, fmtNum, fmtQty } from "../../lib/format";
  import Money from "../../components/Money.svelte";
  import Signed from "../../components/Signed.svelte";
  let { list, withName = false }: { list: readonly RealizedEntry[]; withName?: boolean } = $props();
</script>

<div class="table-wrap"><table><thead><tr><th class="l">Sprzedaż</th><th class="l">Nabycie</th>{#if withName}<th class="l">Instrument</th>{/if}<th class="l">Rachunek</th><th>Ilość</th>
  <th>Przychód (waluta)</th><th>Kurs NBP</th><th>Przychód PLN</th><th>Koszt (waluta)</th><th>Kurs NBP</th><th>Koszt PLN</th><th>Dochód PLN</th><th>Dni</th></tr></thead>
  <tbody>
    {#each list as x, i (i)}
      <tr><td class="l">{fmtDate(x.closeDay)}</td><td class="l">{fmtDate(x.openDay)}</td>{#if withName}<td class="l">{app.model?.instr[x.symbol]?.name ?? ""} <span class="muted small">{x.symbol}</span></td>{/if}<td class="l">{x.account}</td>
        <td>{fmtQty(x.qty)}</td><td><Money v={x.proceedsCur} d={2} ccy={x.ccy} /></td><td>{fmtNum(x.fxSell, 4)}</td><td><Money v={x.proceedsPLN} d={2} /></td>
        <td>{#if x.incomplete}<span class="badge warn">brak</span>{:else}<Money v={x.costCur} d={2} ccy={x.costCcy || x.ccy} />{/if}</td><td>{x.fxBuy ? fmtNum(x.fxBuy, 4) : "–"}</td><td><Money v={x.costPLN} d={2} /></td><td><Signed v={x.gainPLN} d={2} /></td><td>{x.days ?? "–"}</td></tr>
    {/each}
  </tbody>
</table></div>
